export const EXPERT_TAB_LABEL = 'Experts';
export const PEOPLE_TAB_LABEL = 'People';
export const COMPNAY_TAB_LABEL = 'People';
export const STACKOVERFLOW_TAB_LABEL= 'Stackoverflow';
export const BOTH_PEOPLE_STACKOVERFLOW_TAB_LABELL= 'Stackoverflow';
export const AI_USAGE_INFO_TO_USER = "Industries AI Toolkit utilize OpenAI's Large Language Model within the Einstein LLM Gateway for specific tools";
export const AI_TOOLKIT_URL = {
  'DEV':"http://127.0.0.1:5000/",
  'PROD':"https://industries-ai-toolkit-ebe9a0bdb829.herokuapp.com/",
  'STAGE': "https://industries-ai-toolkit-stage-c339ab461e7f.herokuapp.com/"
}

export const ADMIN = 'Admin';
export const SALESFORCE_EMAIL_EXPRESSION = /^([A-Za-z0-9]+[.-_])*[A-Za-z0-9]+@(salesforce\.com)+$/;
export const LOAD_DATA_FROM_CACHE = false;
export const CLIENT_ID = {
  "PROD": '954241880106-pf24pqj7ar650ukqoro71qkdgr1vr0dh.apps.googleusercontent.com',
  "DEV": '954241880106-pf24pqj7ar650ukqoro71qkdgr1vr0dh.apps.googleusercontent.com',
  "STAGE": '954241880106-pf24pqj7ar650ukqoro71qkdgr1vr0dh.apps.googleusercontent.com'

};

export const AITOOLKIT_GOOGLE_ANALYTICS_ID='G-QLYEL45MX9';
